import React from 'react';
import styles from './DataTable.scss';

interface HeaderColumn {
    title: string;
}

interface DataTableProps<T> {
    id: string;
    headerColumns: HeaderColumn[];
    renderRow: (row: T) => React.ReactNode;
    data: T[];
}

const DataTable = function DataTable<T>({ id, headerColumns, renderRow, data }: DataTableProps<T>) {
    return (
        <div id={`${id}-table`} className={styles.table_container}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        {headerColumns.map((column) => (
                            <th
                                key={column.title}
                                className={styles.table_heading}
                            >
                                {column.title}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row) => renderRow(row))}
                </tbody>
            </table>
            <div className={styles.table_footer} />
        </div>
    );
};

export default DataTable;
